<template>
  <div class="d-flex justify-end">
    <v-btn
      color="primary"
      elevation="0"
      @click="$emit('next')"
      :disabled="disabled"
    >
      <v-icon>mdi-chevron-right</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  props: ['disabled']
}
</script>